import axios from '@/libs/api.request'
import {getToken} from '@/libs/util'
import config from '@/config'

// const MemFlowBaseUrl = 'http://127.0.0.1:8002/api/1.0/flow/svnflow/'
// 持续发布基础URL
const baseDeployUrl = config.baseDeployUrl
const MemFlowBaseUrl = baseDeployUrl + '/api/1.0/flow/member/'

const baseHeaders = {
  'Authorization': 'OPS ' + getToken()
}

export const getList = (params) => {
  return axios.request({
    url: MemFlowBaseUrl + 'list',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const saveMemberFlow = (data) => {
  return axios.request({
    url: MemFlowBaseUrl + 'create',
    headers: baseHeaders,
    data: data,
    method: 'post'
  })
}

export const getMemFlowDetail = (params) => {
  return axios.request({
    url: MemFlowBaseUrl + params.id,
    headers: baseHeaders,
    method: 'get'
  })
}
